import React, { Fragment, Component } from 'react'
// import { Table, Button } from 'semantic-ui-react'

import AddModal from '../components/AddModal'
import Page from '../components/Page'

class CalwinServers extends Component {
    state = {
        reports: [{ id: 1 }],
        filteredList: [{ id: 1 }],
        loading: false,
        error: null,
    }

    filterList = text => {
        console.log(text)
    }

    render() {
        const { filteredList, loading, error } = this.state

        return (
            <Page
                icon="database"
                name="CalWin Server"
                length={filteredList.length}
                loading={loading}
                error={error}
                onFilterChange={this.filterList}
                tableHeaders={["ID", "CalWin Server", "URL", "Enabled", "Test-server", "Created", ""]}
                tableBody={() => (
                    <Fragment>
                        {/* {filteredList.map(report =>
                            <Table.Row key={report.id} >
                                <Table.Cell>{report.id}</Table.Cell>
                                <Table.Cell>{report.name}</Table.Cell>
                                <Table.Cell>{report.manufacturer}</Table.Cell>
                                <Table.Cell>{report.created}</Table.Cell>
                                <Table.Cell collapsing>
                                    <Fragment>
                                        <Button primary content="Select" />
                                        <Button color="black" content="Delete" />
                                    </Fragment>
                                </Table.Cell>
                            </Table.Row>
                        )} */}
                    </Fragment>
                )}
                addNew={() => (
                    <AddModal
                        header="CalWin server"
                        fields={["name",]}
                        onSave={() => window.alert("hmm")}
                    />
                )}
            />
        )
    }
}

export default CalwinServers

